import React from 'react';

import { SentryRoute as Route, SentryRoutes as Routes } from 'config/sentry';

import InstallCallbackAgriWebb from './AgriWebb/InstallCallback';
import SiteFarmMappingAgriWebb from './AgriWebb/SiteFarmMapping';

const Integrations = () => {
  return (
    <Routes>
      <Route path="agriwebb/install-callback" element={<InstallCallbackAgriWebb />} />
      <Route path="agriwebb/site-mapping" element={<SiteFarmMappingAgriWebb />} />
    </Routes>
  );
};

export default Integrations;
